import './projects.less';
import Slider from '../slider/index';
import ProjectItem from './project-item';

// trim-below
import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

const b = block('projects');

const Projects = ({list}) => {
	return (
		<div className={b()}>
			<p className={b('summary')}>Μερικά από τα έργα μας. Για να δείτε περισσότερα επισκεφτείτε την σελίδα <a className={b('link')} href="/projects" title="έργα">έργα</a></p>
			<Slider
				className={b()}
				count={list.length}
				mode="carousel"
				items={4}
				gutter={26}
				placeholders={
					list.map((item, index) => (
						<ProjectItem key={index} {...item} />
					))
				}
			/>
		</div>
	);
}

Projects.propTypes = {
	list: PropTypes.array.isRequired
};

export default Projects;



// WEBPACK FOOTER //
// ./src/components/projects/index.jsx